var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForbesGeorgiaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 197 49.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "forbesGEORGIA-logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    className: "cls-1",
    d: "M173.5,9.6a4.47,4.47,0,0,1-1.26.19,2.06,2.06,0,0,1-1.54-.51,1.82,1.82,0,0,1-.51-1.38,1.93,1.93,0,0,1,1.87-2h.26a2.16,2.16,0,0,1,1,.2l-.2.67a2.35,2.35,0,0,0-.87-.16,1.16,1.16,0,0,0-1.26,1,1.34,1.34,0,0,0,0,.2,1.11,1.11,0,0,0,1,1.22h.19a2.58,2.58,0,0,0,.4,0V8.25H172V7.58h1.38v2Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    className: "cls-1",
    d: "M177.06,8.17h-1.38V9h1.54v.71h-2.37V6h2.29v.71h-1.46v.75h1.38Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    className: "cls-1",
    d: "M179.19,7.9c0,.75.35,1.26.91,1.26s.91-.55.91-1.26-.32-1.27-.91-1.27-.91.52-.91,1.27m2.72,0a1.79,1.79,0,0,1-1.6,2,1.07,1.07,0,0,1-.25,0,1.74,1.74,0,0,1-1.78-1.72V7.94A1.84,1.84,0,0,1,180,6h.14a1.71,1.71,0,0,1,1.82,1.61,1.31,1.31,0,0,1,0,.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    className: "cls-1",
    d: "M184,7.66h.31c.44,0,.67-.2.67-.55s-.23-.52-.63-.52a1,1,0,0,0-.39,0v1ZM183.14,6A8.74,8.74,0,0,1,184.28,6a2,2,0,0,1,1.23.28.92.92,0,0,1,.35.79,1,1,0,0,1-.67.91h0c.28.11.4.35.51.7A9.93,9.93,0,0,0,186,9.7h-.87a4.29,4.29,0,0,1-.23-.87c-.12-.47-.28-.59-.64-.59h-.23V9.7h-.83V6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    className: "cls-1",
    d: "M190.25,9.6a4.54,4.54,0,0,1-1.27.19,2.08,2.08,0,0,1-1.54-.51,1.86,1.86,0,0,1-.51-1.38,1.93,1.93,0,0,1,1.87-2h.26a2.14,2.14,0,0,1,1,.2l-.2.67a2.32,2.32,0,0,0-.87-.16,1.16,1.16,0,0,0-1.26,1v.2a1.11,1.11,0,0,0,1,1.22h.2a2.58,2.58,0,0,0,.39,0V8.25h-.47V7.58h1.38Z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    className: "cls-1",
    x: 191.59,
    y: 6,
    width: 0.83,
    height: 3.75
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-1",
    d: "M195.66,8.17l-.24-.79c-.08-.23-.12-.51-.2-.7h0c0,.23-.12.51-.16.7l-.23.79Zm-.95.64-.28.94h-.87L194.71,6h1.1L197,9.75h-.91l-.28-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "cls-1",
    d: "M112.06,0,96.9,2.72V4.07l1.59.23c2.05.44,2.72,1.59,3.16,4.31.43,5.45.23,34.43,0,39.16a58.76,58.76,0,0,0,12.67,1.59c12,0,19.23-7.46,19.23-19.23,0-9.28-5.88-16.07-13.58-16.07a15.88,15.88,0,0,0-8.14,2c0-7.26,0-13.86.24-16.11m2.73,46.87a10,10,0,0,1-2.73-.23c-.24-3.16-.43-16.55-.24-28.32a10.7,10.7,0,0,1,3.4-.67c5,0,7.7,5.89,7.7,13.15,0,9-3.39,16.08-8.13,16.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-1",
    d: "M39.84.91H0V3l2.25.24c3,.43,4.07,2.25,4.54,6.55a266.11,266.11,0,0,1,0,29.89C6.36,44,5.2,46,2.25,46.2L0,46.67v1.82H25.58V46.63l-2.72-.47c-3-.24-4.07-2.25-4.54-6.56-.24-3-.44-7.7-.44-13.58l5.45.24c3.4,0,5,2.72,5.65,6.55H31V16.74H29c-.67,3.83-2.25,6.55-5.64,6.55l-5.45.24c0-7.7.23-14.92.43-19.23h7.94c6.12,0,9.28,3.83,11.53,10.66L40,14.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    className: "cls-1",
    d: "M52.75,13.58c-11.34,0-17.65,8.14-17.65,17.89,0,10.19,5.65,17.89,17,17.89s17.65-8.14,17.65-17.89c0-10.19-5.65-17.89-17-17.89M52.51,47.1c-4.54,0-6.79-7-6.79-15.63,0-8.85,1.34-15.64,6.35-15.64,4.74,0,7,7,7,15.64,0,8.84-1.38,15.63-6.6,15.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    className: "cls-1",
    d: "M154,13.58c-11.53,0-17.45,8.85-17.45,18.13,0,10.42,7.23,17.64,17.45,17.64A16.81,16.81,0,0,0,167.54,43l-.91-1.15a11.57,11.57,0,0,1-7.7,2.49c-8.13,0-12.24-6.12-12-14.49h21c0-9.24-4.5-16.27-14-16.27m-7,13.82c.23-5.21,2.25-11.53,6.12-11.53s4.54,6.79,4.54,11.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    className: "cls-1",
    d: "M184.52,13.58c-8.37,0-13.58,5-13.58,10.86s3.83,8.37,9.28,10.19c5.64,2,7.23,3.63,7.23,6.35a5.25,5.25,0,0,1-5.27,5.23l-.37,0c-4.31,0-7.47-2.49-9.95-9.28l-1.59.48.23,10a35.53,35.53,0,0,0,12,2c8.85,0,14.49-4.54,14.49-11.53,0-4.74-2.49-7.46-8.37-9.75-6.35-2.49-8.61-4.07-8.61-7a4.7,4.7,0,0,1,4.4-5h.34c4.07,0,6.79,2.49,8.85,8.61l1.59-.43L195,15.43a26.57,26.57,0,0,0-10.43-1.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    className: "cls-1",
    d: "M95.24,13.46c-3.59,0-7.78,2.26-10.34,8.06l.23-7.94L70,16.54v1.35l1.59.23c2,.24,3,1.34,3.16,4.31a196.13,196.13,0,0,1,0,19.7c-.24,2.73-1.15,4.07-3.16,4.31L70,46.67v1.82H91V46.63l-2.73-.23c-2.25-.24-3-1.59-3.16-4.31a173,173,0,0,1-.23-18.36A6.28,6.28,0,0,1,89.79,22a10.43,10.43,0,0,1,5.73,1.74l3.63-9.28a8.2,8.2,0,0,0-3.91-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForbesGeorgiaLogo);
export default __webpack_public_path__ + "static/media/forbes-georgia-logo.b689e109f4677cd1948c38b0c3914258.svg";
export { ForwardRef as ReactComponent };